<div class="vtr-ui-rounded-rectangle-custom-radio-list">
	<div role="radiogroup"
		class="radio-group"
		class="{{ isVertical ? 'vertical': 'horizontal'}}"
		#radioGroupRef
		(keydown)="onKeyDown($event)"
		(blur)="onRadioGroupBlur($event)"
		(focus)="onRadioGroupFocus($event)"
		[id]="groupName"
		[vtrDisabled]="isDisabled">
		<ng-template ngFor
			let-item
			[ngForOf]="radioDetails"
			let-index="index">
			<div role="radio"
				#radioRef
				[id]="item.componentId"
				[tabIndex]="isDisabled?-1:0"
				[class.focus]="item.componentId === focusedComponentId"
				[attr.aria-checked]="item.isChecked"
				[attr.aria-disabled]="isDisabled"
				[attr.aria-label]="item.label | translate"
				(click)="onClick($event)"
				(keydown.enter)="onClick($event)">
				{{item.label | translate}}
			</div>
		</ng-template>
	</div>
</div>
